module.exports = __webpack_public_path__ + "static/media/iphone_screen7.95049420.png";